import { ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { ProductInformation } from '../../shared/productInformation.entity';
import { RungisSupplierService } from '../../services/rungis-supplier.service';
import { AdditiveProductInformation } from '../../shared/additiveProductInformation.entity';
import { FileUploadService } from 'src/modules/sm-base/services/file-upload-service';
import { Utils } from 'src/modules/utils/shared/utils';
import { CustomsNumber } from '../../shared/customsNumber.entity';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { NgForm } from '@angular/forms';
import { Additive } from '../../shared/additive.entity';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';

@Component({
  selector: 'app-rungis-supplier',
  templateUrl: './rungis-supplier.component.html',
  styleUrls: ['./rungis-supplier.component.scss']
})
export class RungisSupplierComponent extends ComponentView {
 
  app = inject(MainAppService);
  service = inject(RungisSupplierService);
  messageService = inject(MessageService);
  fileUpload = inject(FileUploadService);
  cdr = inject(ChangeDetectorRef);

  _Utils = Utils;

  id: string;
  productInformation: ProductInformation;
  customsNumbers: CustomsNumber[];
  allAdditives: Additive[];
  selectedAdditives: { [category: string]: AdditiveProductInformation[] } = {};
  uniqueCategories: string[];
  groupedAdditives: { [category: string]: AdditiveProductInformation[] } = {};
  formValid = true;
  customsNumberValid = false;

  neededParams: ObjectOfSimpleDataTypes = { id: "string" };

  activeTab = 0;
  formDate = new Date();

    @ViewChild("supplierForm") supplierForm: NgForm;

  async initParams(): Promise<boolean> {
    await this.reload();
    if (this.productInformation.requestPostProcessing) {
        
        this.productInformation.logisticsEANPieceNotAvailable = this.productInformation.logisticsEANPiece == "" || this.productInformation.logisticsEANPiece == "0";
        this.productInformation.logisticsEANBoxNotAvailable = this.productInformation.logisticsEANBox == "" || this.productInformation.logisticsEANBox == "0";
        this.productInformation.logisticsNetWeightPieceNotAvailable = this.productInformation.logisticsNetWeightPiece == "" || this.productInformation.logisticsNetWeightPiece == "0";
        this.productInformation.logisticsNetWeightBoxNotAvailable = this.productInformation.logisticsNetWeightBox == "" || this.productInformation.logisticsNetWeightBox == "0";
        this.productInformation.logisticsGrossWeightPieceNotAvailable = this.productInformation.logisticsGrossWeightPiece == "" || this.productInformation.logisticsGrossWeightPiece == "0";
        this.productInformation.logisticsGrossWeightBoxNotAvailable = this.productInformation.logisticsGrossWeightBox == "" || this.productInformation.logisticsGrossWeightBox == "0";
        this.productInformation.logisticsDimensionsPieceNotAvailable = 
            (this.productInformation.logisticsDimensionsPieceB == "" || this.productInformation.logisticsDimensionsPieceB == "0") && 
            (this.productInformation.logisticsDimensionsPieceH == "" || this.productInformation.logisticsDimensionsPieceH == "0") &&
            (this.productInformation.logisticsDimensionsPieceL == "" || this.productInformation.logisticsDimensionsPieceL == "0");
            this.productInformation.logisticsDimensionsBoxNotAvailable = 
            (this.productInformation.logisticsDimensionsBoxB == "" || this.productInformation.logisticsDimensionsBoxB == "0") && 
            (this.productInformation.logisticsDimensionsBoxH == "" || this.productInformation.logisticsDimensionsBoxH == "0") &&
            (this.productInformation.logisticsDimensionsBoxL == "" || this.productInformation.logisticsDimensionsBoxL == "0");
        this.productInformation.packagingAluminumWeightNotAvailable = this.productInformation.packagingAluminumWeight == "" || this.productInformation.packagingAluminumWeight == "0";
        this.productInformation.packagingCompositeWeightNotAvailable = this.productInformation.packagingCompositeWeight == "" || this.productInformation.packagingCompositeWeight == "0";
        this.productInformation.packagingGlassWeightNotAvailable = this.productInformation.packagingGlassWeight == "" || this.productInformation.packagingGlassWeight == "0";
        this.productInformation.packagingNaturalWeightNotAvailable = this.productInformation.packagingNaturalWeight == "" || this.productInformation.packagingNaturalWeight == "0";
        this.productInformation.packagingPaperWeightNotAvailable = this.productInformation.packagingPaperWeight == "" || this.productInformation.packagingPaperWeight == "0";
        this.productInformation.packagingPlasticWeightNotAvailable = this.productInformation.packagingPlasticWeight == "" || this.productInformation.packagingPlasticWeight == "0";
        this.productInformation.packagingTinplateWeightNotAvailable = this.productInformation.packagingTinplateWeight == "" || this.productInformation.packagingTinplateWeight == "0";
        this.productInformation.hintsGeneticallyModified = this.productInformation.hintsGeneticallyModified != "" ? this.productInformation.hintsGeneticallyModified : "Nicht vorhanden";
        this.productInformation.hintsProducedGeneticallyModifiedOrganisms = this.productInformation.hintsProducedGeneticallyModifiedOrganisms != "" ? this.productInformation.hintsProducedGeneticallyModifiedOrganisms : "Nicht vorhanden";
        this.productInformation.hintsObtainedGeneticallyModifiedOrganisms = this.productInformation.hintsObtainedGeneticallyModifiedOrganisms != "" ? this.productInformation.hintsObtainedGeneticallyModifiedOrganisms : "Nicht vorhanden";
        this.productInformation.hintsIonizingRadiation = this.productInformation.hintsIonizingRadiation != "" ? this.productInformation.hintsIonizingRadiation : "Nicht vorhanden";
        this.productInformation.hintsIonizingRadiationIngredients = this.productInformation.hintsIonizingRadiationIngredients != "" ? this.productInformation.hintsIonizingRadiationIngredients : "Nicht vorhanden";
        this.productInformation.detailsSpecificationChecked = true;
        this.productInformation.detailsGermanLabel = "yes";
        this.productInformation.uploadRequired = false;
    }
    this.productInformation.confirmationDate = new Date();
    this.allAdditives = await this.service.getAdditives();
    this.uniqueCategories = this.getUniqueCategories();
    this.groupAdditivesByCategory();
    this.customsNumbers = await this.service.getCustomsNumbers();

    this.productInformation.additives.forEach(additive => {
      additive.additive = this.allAdditives.find(a => a.eNumber == additive.eNumber && a.category == additive.category);
      additive.label = additive.eNumber + " - " + (
        this.app.language == "de" ? additive.additive?.descriptionGerman :  
        this.app.language == "en" ? additive.additive?.descriptionEnglish : 
        this.app.language == "fr" ? additive.additive?.descriptionFrench : 
        this.app.language == "es" ? additive.additive?.descriptionSpanish : "???");
      if (additive.active) {
        if (!this.selectedAdditives[additive.category]) {
          this.selectedAdditives[additive.category] = [];
        }
        this.selectedAdditives[additive.category].push(additive);
      }
    });
    if (this.productInformation.detailsCustomsFeeNumber.length > 0) {
      this.checkCustomsNumber();
    }

    return true;
  }

  groupAdditivesByCategory(): void {
    this.uniqueCategories = Array.from(new Set(this.productInformation.additives.map(additive => additive.category)));
    for (const category of this.uniqueCategories) {
      this.groupedAdditives[category] = this.productInformation.additives.filter(additive => additive.category === category);
    }
  }

  onAdditiveSelectionChange(selectedAdditives: AdditiveProductInformation[], _category: string): void {
    selectedAdditives.forEach(additive => {
      additive.active = true;
      const index = this.productInformation.additives.findIndex(a => a.id === additive.id);
      if (index !== -1) {
        this.productInformation.additives[index].active = true;
      }
    });
  }

  getUniqueCategories(): string[] {
    const uniqueCategories: string[] = [];
    for (const additive of this.productInformation.additives) {
      if (!uniqueCategories.includes(additive.category)) {
        uniqueCategories.push(additive.category);
      }
    }
    return uniqueCategories;
  }

  getAdditivesForCategory(category: string): { name: string; value: string; lbl: string }[] {
    const additivesForCategory: { name: string; value: string; lbl: string }[] = [];
    const additives = this.productInformation.additives.filter(additive => additive.category === category);
    for (const additive of additives) {
      const formattedLabel = `${additive.eNumber} - ${additive.additiveDescription}`;
      additivesForCategory.push({
        name: formattedLabel,
        value: additive.eNumber,
        lbl: formattedLabel
      });
    }
    return additivesForCategory;
  }

  calculateGuaranteedBestBefore(): void {
    this.productInformation.detailsGuaranteedBestBefore = Math.ceil(this.productInformation.detailsBestBeforeDays * 0.7);
  }

  calculateTotal(): void {
    this.productInformation.packagingTotalPerPalette = this.productInformation.packagingPiecesPerBox * this.productInformation.packagingBoxesPerLayer * this.productInformation.packagingLayersPerPalette;
  }

  pieceDimensionChecked(): void {
    if (this.productInformation.logisticsDimensionsPieceNotAvailable) {
      this.productInformation.logisticsDimensionsPieceL = "";
      this.productInformation.logisticsDimensionsPieceB = "";
      this.productInformation.logisticsDimensionsPieceH = "";
    }
  }

  boxDimensionChecked(): void {
    if (this.productInformation.logisticsDimensionsPieceNotAvailable) {
      this.productInformation.logisticsDimensionsBoxL = "";
      this.productInformation.logisticsDimensionsBoxB = "";
      this.productInformation.logisticsDimensionsBoxH = "";
    }
  }

  async reload(): Promise<void> {    
    this.productInformation = await this.app.loadDataHandler(() => RestEndpoint.main().query({ id: this.id }).run("api/run/productInformation/byWf").get(ProductInformation, true), this);
  }

  async upload(_, ft: string): Promise<void> {
    if (ft === "productImage" && this.productInformation.detailsProductImagesFiles?.length == 3) {
      this.app.showToast("error", "Upload fehlgeschlagen", "Es können maximal drei Produktbilder hochgeladen werden.");
    }
    else {
      let uploadedFile = await this.fileUpload.chooseFile();
      let uploadedFileContents = uploadedFile[0].contents;
      await this.save();
      await RestEndpoint.main().post().body({ wfId: this.productInformation.wfId, fileType: ft, fileBase64: Utils.bytesToBase64(uploadedFileContents), fileName: uploadedFile[0].legacy.name}).run("api/run/productInformation/upload").getText();
      await this.reload();
    }
}

  async submitForm(): Promise<void> {
    this.productInformation.requestFinished = true;
    await this.save();
    this.app.showToast("success", "Erfolgreich gesendet", "Die Daten wurden erfolgreich gesendet. Sie können dieses Fenster nun schließen.", 20000);
  }

  checkSpecificationDate(): boolean {
    if (!this.productInformation.detailsDateOfSpecification) {
      return false;
    }
    const currentDate = new Date();
    const selectedDate = new Date(this.productInformation.detailsDateOfSpecification);

    const twoYearsAgo = new Date();
    twoYearsAgo.setFullYear(currentDate.getFullYear() - 2);

    return selectedDate < twoYearsAgo;
  }

  checkRequiredBeef(): boolean {
    let required = !this.productInformation.meatButcheredIn && !this.productInformation.meatGrownIn;
    if (!required) {
      this.productInformation.beefBornIn = "";
      this.productInformation.beefButcheredIn = "";
      this.productInformation.beefCutIn = "";
      this.productInformation.beefGrownIn = "";
    }
    return required;
  }

  checkRequiredMeat(): boolean {
    let required = !this.productInformation.beefBornIn && !this.productInformation.beefButcheredIn && !this.productInformation.beefCutIn && !this.productInformation.beefGrownIn;
    if (!required) {
      this.productInformation.meatButcheredIn = "";
      this.productInformation.meatGrownIn = "";
    }
    return required;
  }

  async save(): Promise<void> {
    for (let name of Utils.getOwnPropertyNames(this.supplierForm.controls)) {
        if (this.supplierForm.controls[name].invalid) {
            console.log("Ungültiges Feld: " + name);
        }
    }

    await this.app.saveDataHandler(async () => RestEndpoint.main().body(this.productInformation).post().run("api/run/productInformation").getText(), this, true, false);
  }

   ngAfterViewChecked(): void {
     this.cdr.detectChanges();
   }

  disableAllergens(): void {
    if (this.productInformation.allergenesNotAvailable) {
      this.productInformation.allergens.forEach(allergen => {
        allergen.status = 'nicht vorhanden';
      });
    }
    else {
      this.productInformation.allergens.forEach(allergen => {
        allergen.status = '';
      });
    }
  }

  isEanValid(ean: string): boolean {
    return Utils.isNoe(ean) || Utils.isEanValid(ean);
  }

  fatChanged(): void {
    this.productInformation.nutritionFat = parseFloat(this.productInformation.nutritionFat.toString().replace(",", ".")) > 100 ? "100" : this.productInformation.nutritionFat;
    let total = parseFloat(this.productInformation.nutritionCarbs.toString().replace(",", ".")) + parseFloat(this.productInformation.nutritionFat.toString().replace(",", ".")) + parseFloat(this.productInformation.nutritionProtein.toString().replace(",", ".")) + parseFloat(this.productInformation.nutritionSalt.toString().replace(",", "."));
    if (total > 100) {
      let fatStr = this.productInformation.nutritionFat.toString().replace(",", ".");
      let fat = parseFloat(fatStr);
      let newFat = 100 - (total - fat);
      this.productInformation.nutritionFat = newFat.toString().replace(".", ",");//(100 - (total - parseFloat(this.productInformation.nutritionFat.toString().replace(",", ".")))).toString().replace(".", ",");
    }
  }

  saturatedFatChanged(): void {
    if (Utils.toNumber(this.productInformation.nutritionsaturatedFat) > Utils.toNumber(this.productInformation.nutritionFat)) {
        this.productInformation.nutritionsaturatedFat = this.productInformation.nutritionFat;
    }
  }

  carbsChanged(): void {
    this.productInformation.nutritionCarbs = parseFloat(this.productInformation.nutritionCarbs.toString().replace(",", ".")) > 100 ? "100" : this.productInformation.nutritionCarbs;
    let total = parseFloat(this.productInformation.nutritionCarbs.toString().replace(",", ".")) + parseFloat(this.productInformation.nutritionFat.toString().replace(",", ".")) + parseFloat(this.productInformation.nutritionProtein.toString().replace(",", ".")) + parseFloat(this.productInformation.nutritionSalt.toString().replace(",", "."));
    if (total > 100) {
      let carbsStr = this.productInformation.nutritionCarbs.toString().replace(",", ".");
      let carbs = parseFloat(carbsStr);
      let newCarbs = 100 - (total - carbs);
      this.productInformation.nutritionCarbs = newCarbs.toString().replace(".", ",");//(100 - (total - parseFloat(this.productInformation.nutritionCarbs.toString().replace(",", ".")))).toString().replace(".", ",");
    }
  }

  proteinChanged(): void {
    this.productInformation.nutritionProtein = parseFloat(this.productInformation.nutritionProtein.toString().replace(",", ".")) > 100 ? "100" : this.productInformation.nutritionProtein;
    let total = parseFloat(this.productInformation.nutritionCarbs.toString().replace(",", ".")) + parseFloat(this.productInformation.nutritionFat.toString().replace(",", ".")) + parseFloat(this.productInformation.nutritionProtein.toString().replace(",", ".")) + parseFloat(this.productInformation.nutritionSalt.toString().replace(",", "."));
    if (total > 100) {
      let proteinStr = this.productInformation.nutritionProtein.toString().replace(",", ".");
      let protein = parseFloat(proteinStr);
      let newProtein = 100 - (total - protein);
      this.productInformation.nutritionProtein = newProtein.toString().replace(".", ",");//(100 - (total - parseFloat(this.productInformation.nutritionProtein.toString().replace(",", ".")))).toString().replace(".", ",");
    }
  }

  saltChanged(): void {
    this.productInformation.nutritionSalt = parseFloat(this.productInformation.nutritionSalt.toString().replace(",", ".")) > 100 ? "100" : this.productInformation.nutritionSalt;
    let total = parseFloat(this.productInformation.nutritionCarbs.toString().replace(",", ".")) + parseFloat(this.productInformation.nutritionFat.toString().replace(",", ".")) + parseFloat(this.productInformation.nutritionProtein.toString().replace(",", ".")) + parseFloat(this.productInformation.nutritionSalt.toString().replace(",", "."));
    if (total > 100) {
      let saltStr = this.productInformation.nutritionSalt.toString().replace(",", ".");
      let salt = parseFloat(saltStr);
      let newSalt = 100 - (total - salt);
      this.productInformation.nutritionSalt = newSalt.toString().replace(".", ",");//(100 - (total - parseFloat(this.productInformation.nutritionSalt.toString().replace(",", ".")))).toString().replace(".", ",");
    }
  }

  checkNutrition(): void {
    if (this.productInformation.nutritionNA == "erforderlich") {
      this.productInformation.nutritionCarbSugarNA = false;
      this.productInformation.nutritionCarbsNA = false;
      this.productInformation.nutritionFatNA = false;
      this.productInformation.nutritionKjKcalNA = false;
      this.productInformation.nutritionProteinNA = false;
      this.productInformation.nutritionSaltNA = false;
      this.productInformation.nutritionSaturatedFatNA = false;
    }
    else {
      this.productInformation.nutritionCarbSugarNA = true;
      this.productInformation.nutritionCarbsNA = true;
      this.productInformation.nutritionFatNA = true;
      this.productInformation.nutritionKjKcalNA = true;
      this.productInformation.nutritionProteinNA = true;
      this.productInformation.nutritionSaltNA = true;
      this.productInformation.nutritionSaturatedFatNA = true;

      this.productInformation.nutritionCarbs = "0";
      this.productInformation.nutritionCarbsSugar = "0";
      this.productInformation.nutritionFat = "0";
      this.productInformation.nutritionsaturatedFat = "0";
      this.productInformation.nutritionKjKcal = "0";
      this.productInformation.nutritionProtein = "0";
      this.productInformation.nutritionSalt = "0";
    }
  }

  // async checkCustomsNumber(): Promise<void> {
  //     let result = await RestEndpoint.main().run("api/run/productInformation/customsNumber?number=" + this.productInformation.detailsCustomsFeeNumber).getText();

  //     this.customsNumberValid = JSON.parse(result).duties.length > 0;

  //     if (!this.customsNumberValid) {
  //       this.app.showToast("error", "Fehler", "Die Zolltarif-Nr. ist ungültig.");
  //     }
  // }

  checkCustomsNumber(): void {
        let customsNo = this.customsNumbers.find(c => c.customsNumber === this.productInformation.detailsCustomsFeeNumber);
        this.customsNumberValid = customsNo?.customsNumber.length > 0;

        if (!this.customsNumberValid) {
          this.app.showToast("error", "Fehler", "Die Zolltarif-Nr. ist ungültig.");
        }

        this.productInformation.customsNumberDescription = this.customsNumberValid ? 
            this.app.language == "de" ? customsNo.descriptionGerman :  
            this.app.language == "en" ? customsNo.descriptionEnglish : 
            this.app.language == "fr" ? customsNo.descriptionFrench : 
            this.app.language == "es" ? customsNo.descriptionSpanish : '' : '';
  }

  inlandFisheriesChanged(): void {
    if (!this.productInformation.fishInlandFisheries) {
      this.productInformation.fishInlandOrigin = "";
      this.productInformation.fishInlandGearCategory = "";
    }
  }

  wildCaughtChanged(): void {
    if (!this.productInformation.fishWildCaught) {
      this.productInformation.fishWildGearCategory = "";
      this.productInformation.fishCatchmentArea = "";
      this.productInformation.fishSubCatchmentArea = "";
    }
  }

  aquacultureChanged(): void {
    if (!this.productInformation.fishAquaculture) {
      this.productInformation.fishOriginAC = "";
    }
  }
}
